import type { ModalCloseReason } from '~/components/StandardModal/types';
import DismissInteractionEvent, {
  type DismissBannerType
} from '~/events/DismissInteractionEvent';
import useRootData from '~/hooks/useRootData';
import useUser from '~/hooks/useUser';
import type { ModalScreen } from '~/utils/modalProperties';

export default function useDismissInteraction(bannerType: DismissBannerType) {
  const { isBot } = useRootData();
  const user = useUser();

  return () =>
    new DismissInteractionEvent({
      bannerType,
      gesture: 'click',
      guestId: user.guestId,
      isBot,
      placement: 'dismiss_button'
    }).send();
}

export function useModalDismissInteraction(screen: ModalScreen) {
  const { isBot } = useRootData();
  const user = useUser();

  return (placement: ModalCloseReason) =>
    new DismissInteractionEvent({
      gesture: placement === 'escape_key' ? 'keypress' : 'click',
      guestId: user.guestId,
      isBot,
      modal: screen,
      placement
    }).send();
}
